import React from 'react'
import { connect } from 'react-redux'
import { Button as ButtonBS } from 'react-bootstrap'
import { MEDIA_BREAKPOINT_LG } from '../../../../utilities/breakpoints'
import { normalizeNumberSpaces } from '../../../../utilities/normalize'

import { saveAds } from '../../../../store/Modal/types/AdsEdit/actions'
import { stopTrack } from '../../../../store/AudioPlayer/actions'

import Header from '../../components/header'

import Uploader from '../../../Uploader'
import Select from '../../../Form/Select'
import InputText from '../../../Form/InputText'
import InputTextarea from '../../../Form/InputTextarea'


import { loadVideolists } from "../../../../store/ContentVideolists/actions";

import Track from '../../../Tracks/Track/HistoryTrack'
import ClipHistory from '../../../ClipHistory'


class AdsEdit extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            sumbitDisabled: false,
            text: this.props.adsData.text || '',
            ...this.props.adsData,
            pri: this.props.adsData.pri || null
        }

        this.hSubmit = this.hSubmit.bind(this)
        this.hLoadfile = this.hLoadfile.bind(this)
        this.hInputText = this.hInputText.bind(this)
        this.validateForm = this.validateFrom.bind(this)
        this.allowedTypes = [".mp4", ".3gp", ".mkv", ".avi", ".wmv", ".mpeg", ".mpga", ".mpgv",
            ".mp3", ".aac", ".wav", ".flac", ".ogg",
            ".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"]
    }

    hLoadfile(file) {
        this.setState(() => ({
            filename: file,
            //name: file.name,
            origname: file.name,
            size: file.size,
            cliptime: "—",
        }), this.validateFrom)
    }

    hInputText({ name, value }) {
        if (name) {
            this.setState(() => ({
                [name]: value
            }), this.validateFrom)
        }
    }

    hSubmit() {
        this.props.saveAds({
            id: this.state.id,
            dataToSave: {
                filename: this.state.filename,
                videolist_id: this.state.videolist_id,
                name: this.state.name,
                text: this.state.text,
                ...(this.state.pri && !!this.state.pri.length ? { pri: this.state.pri } : {})
            }
        })
    }


    validatePriFormat = (val) => {
        if (!val)
            return true
        const regex = /^[-]\d+$/;
        const regex2 = /^\d+$/;
        return (regex.test(val) || regex2.test(val));
    };

    validateFrom() {
        if (true
            && (typeof this.state.name === "string" && this.state.name.length > 1 && this.validatePriFormat(this.state.pri))
        ) {
            this.setState({ sumbitDisabled: false })
        } else {
            this.setState({ sumbitDisabled: true })
        }
    }

    componentDidMount() {
        this.props.loadVideolists()
    }

    componentWillUnmount() {
        this.props.stopTrack()
    }

    render() {
        console.log("adsData", this.state);
        return (
            <div className="ModalAdsEdit">
                <Header
                    title="Редактирование ролика"
                    toggleOpened={this.props.toggleOpened}
                />

                <div className="ModalDoubleGrid">
                    <div className="ModalDoubleGrid__left">
                        <div className="ModalDoubleGrid__title">
                            Настройка
                        </div>
                        <InputText
                            label="Название"
                            comment="* Внимание! Если имя файла не задано, звук будет импортирован из выбранного по-умолчанию"
                            attrs={{
                                placeholder: "Название ролика",
                                value: this.state.name,
                                name: "name"
                            }}
                            onChange={this.hInputText}

                        />
                        <div className="ModalAdsCreate__grid" style={{ marginTop: 12 }}>

                            <Select
                                label="Привязать фоновый контент"
                                type="options"
                                onChange={this.hInputText}
                                selected={this.state.videolist_id}
                                value={this.state.videolist_id}
                                name="videolist_id"
                                placeholder="Не привязывать"
                                options={this.props.allVideolists}
                            />
                            <InputText
                                label="Приоритет"
                                attrs={{
                                    placeholder: "Введите приоритет",
                                    value: this.state.pri,
                                    name: "pri"
                                }}
                                onChange={this.hInputText}
                            />


                        </div>

                        <div style={{ marginTop: 48 }}>
                            <InputTextarea
                                label="Текст рекламы"
                                attrs={{
                                    placeholder: "Текст рекламы",
                                    value: this.state.text,
                                    name: "text"
                                }}
                                onChange={this.hInputText}
                            />
                        </div>
                        {window.outerWidth > MEDIA_BREAKPOINT_LG &&
                            <Uploader
                                label="Замена файла"
                                attrs={{
                                    name: "filename",
                                    accept: this.allowedTypes.join(',')
                                }}
                                trackName={this.state.origname}
                                fileTypes={this.allowedTypes}
                                onChange={this.hLoadfile}
                            />
                        }

                    </div>

                    <div className="ModalDoubleGrid__right">
                        <div className="ModalDoubleGrid__title">
                            Информация
                        </div>

                        {window.outerWidth <= MEDIA_BREAKPOINT_LG &&
                            <Uploader
                                label="Замена файла"
                                attrs={{
                                    name: "filename",
                                    accept: ".mp3,.mp4"
                                }}
                                trackName={this.state.origname}
                                fileTypes={[".mp3", ".mp4"]}
                                onChange={this.hLoadfile}
                            />
                        }

                        <div className="ModalDoubleGrid__info">
                            <div className="label lables-titles">Оригинальное имя файла</div>
                            <div className="info">
                                {this.state.origname}
                            </div>
                        </div>

                        <div className="ModalDoubleGrid__info">
                            <div className="label lables-titles">Время звучания</div>
                            <div className="info">
                                {normalizeThisTime(this.state.cliptime)}
                            </div>
                        </div>

                        <div className="ModalDoubleGrid__info">
                            <div className="label lables-titles">Последняя модификация</div>
                            <div className="info">
                                {normalizeThisTime(this.state.mtime)}
                            </div>
                        </div>

                        <div className="ModalDoubleGrid__info">
                            <div className="label lables-titles">Размер в килобайтах</div>
                            <div className="info">
                                {Math.ceil(this.state.size / 1000).toLocaleString()} КБ
                            </div>
                        </div>

                        <div className="ModalDoubleGrid__info">
                            <div className="label lables-titles">Время создания</div>
                            <div className="info">
                                {normalizeThisTime(this.state.ctime)}
                            </div>
                        </div>
                        <div className="ModalDoubleGrid__info">
                            <div className="label lables-titles">История изменений</div>

                            <ClipHistory clipId={this.state.id} />
                        </div>
                    </div>
                </div>

                <div className="Modal__footer">
                    <ButtonBS variant="primary" onClick={this.hSubmit}
                        disabled={this.state.sumbitDisabled || this.props.loading}>
                        {this.props.loading ? "Сохранение..." : "Сохранить"}
                    </ButtonBS>
                </div>
            </div >
        )
    }
}

const stateToProps = state => ({
    adsData: { ...state.modal.types.adsEdit?.adsData || {} },
    loading: state.modalAdsEdit.loading,
    allVideolists: [{ title: "Не привязывать", value: 'NULL' }, ...state.videolists.allVideolists.map((videolist) => ({ title: videolist.name, value: videolist.id, subtitle: `${videolist.totalcount} шт` }))],

})

const actionsToProps = {
    saveAds, loadVideolists,
    stopTrack
}

export default connect(stateToProps, actionsToProps)(AdsEdit)

function normalizeThisTime(time) {
    if (typeof time !== "string") return ""
    return time.split(".")[0]
}

function normalizeSize(size) {
    size = normalizeNumberSpaces(size).split(" ")
    if (size.length >= 2) return `${size[0]} ${size[1]} КБ`
    if (size.length === 1 && size[0].length > 2) return `${size[0]} КБ`
    return "—"
}


